import { Paper, TableContainer, Toolbar, Typography } from "@mui/material";
import React from "react";

type SectionProps = {
  title?: React.ReactNode;
  suffixIcon?: React.ReactNode;
};

export const Section = (props: React.PropsWithChildren<SectionProps>) => {
  const { title, children, suffixIcon } = props;

  return (
    <Paper sx={{ mb: 2, pb: 2, height: "100%" }}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography variant="h6" fontSize={14}>
          {title}
        </Typography>
        {suffixIcon}
      </Toolbar>
      <TableContainer>{children}</TableContainer>
    </Paper>
  );
};
